import { Typography, styled } from "@mui/material";
import { rem } from "polished";
import React from "react";

import { useBrand } from "src/hooks/useBrand";

const StyledTypography = styled(Typography)`
  font-size: ${rem(24)};
  font-weight: bold;
  text-transform: uppercase;
  color: ${(props) => props.theme.palette.primary.contrastText};
`;

export const HeaderLogo = ({ className }: { className?: string }) => {
  const brand = useBrand();
  return (
    <StyledTypography variant="h1" className={className}>
      {brand.customerPortal.name}
    </StyledTypography>
  );
};
